import {createAction, props} from "@ngrx/store";
import {UniverseAccountResource} from "../../models/UniverseAccountResource";

export const UPDATE = '[UniverseAccountResource] Update';
export const REFRESH = '[UniverseAccountResource] Init';
export const update = createAction(UPDATE, props<{ universeAccountResources: UniverseAccountResource[] }>());
export const refresh = createAction(REFRESH);
